export default __webpack_public_path__ + "static/media/loyalty.4c37bb6b.svg";